import "./singleNews.scss";
import template from "./singleNews.html";
import {Base} from "../base";
import {Options} from "vue-class-component";
import {Toast} from "bootstrap";
import {error} from "toastr";
import {NotFound} from "../not-found/not-found";
import imageBackground from "../../assets/img/zen/lora-ohanessian-16rIhtV42yA-unsplash.jpg"

@Options({
	template: template,
})
export class SingleNews extends Base {
	posts: any[] = [];
	email: string = "";
	showModal: boolean = false;
	notFound: any = null;

	/** Lifecycle */
	created() {
		this.init().catch(this.errorHandle);
	}

	mounted() {
		let link = document.getElementById("link-pdf")
		link?.addEventListener("click", (e) => {
			this.showModal = true;
		})
	}

	get image_style() {
		if (this.$wp?.data?.custom_featured_banner?.custom_featured_image?.url) {
			return {
				backgroundImage: `url(${this.$wp?.data?.custom_featured_banner?.custom_featured_image?.url})`
			}
		} else {
			return {
				backgroundImage: `url(${imageBackground})`
			}
		}
	}

	/** Methods */
	async init() {
		if (this.$wp?.data?.post) {
			this.posts = this.$wp.data
			console.log(this.$wp.data)
		} else {
			this.notFound = NotFound;
		}
	}

	async getPdf() {
		try {
			this.loading = true;
			const formData = new FormData();

			formData.append("email", this.email)
			formData.append("link", this.$wp?.data?.conditional_download.gate_link);
			formData.append("emailMessage", this.$wp?.data?.conditional_download.gate_email_message);
			formData.append("emailSubject", this.$wp?.data?.conditional_download.gate_email_subject);

			const res = await this.$api.post("/api/send_pdf.php", formData);

			this.loading = false
			this.showModal = false
			this.email = ''
			new Toast(document.getElementById('toast-email-sent')).show();
		} catch (err) {
			this.errorHandle(err);
		}
	}
}
